import * as Types from '../../../_generated/types.d';

import { GeocodeResponseData } from "@googlemaps/google-maps-services-js";
import { CoachState } from "@portal/app/_common/lib/coach";
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { SignInFlowFragmentFragmentDoc } from '../../generated';
import { FlowStateUpdateFragmentFragmentDoc } from '../../../_components/flow/generated';
export type LoginWithCodeMutationVariables = Types.Exact<{
  code: Types.Scalars['String']['input'];
  email?: Types.InputMaybe<Types.Scalars['Email']['input']>;
  phone?: Types.InputMaybe<Types.Scalars['String']['input']>;
  affiliateSlug?: Types.InputMaybe<Types.Scalars['String']['input']>;
  affiliateExternalId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  affiliateFirstEncounteredAt?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LoginWithCodeMutation = { __typename?: 'Mutation', loginWithCode: { __typename?: 'User', id: string, phoneVerified: boolean | null, emailVerified: boolean | null, tokens: { __typename?: 'ClientAuthToken', accessToken: string, refreshToken: string }, customer: { __typename?: 'Customer', id: string, signInFlow: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } | null } };

export type CreateOneCustomerForCreateAccountMutationVariables = Types.Exact<{
  data: Types.CustomerAndEnrollmentItemCreateInput;
  shouldGetTokens: Types.Scalars['Boolean']['input'];
  programFlow: Types.Scalars['Boolean']['input'];
  programId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  questionnaireFlow: Types.Scalars['Boolean']['input'];
  skipperFlow: Types.Scalars['Boolean']['input'];
  flowIntent?: Types.InputMaybe<Types.FlowIntent>;
  signInFlow: Types.Scalars['Boolean']['input'];
}>;


export type CreateOneCustomerForCreateAccountMutation = { __typename?: 'Mutation', createOneCustomer: { __typename?: 'CustomerAndEnrollmentItem', customer: { __typename?: 'Customer', id: string, user: { __typename?: 'User', id: string, nameFirst: string | null, nameLast: string | null, phone: string | null, email: string | null, tokens?: { __typename?: 'ClientAuthToken', accessToken: string, refreshToken: string } } | null, programFlow?: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } | null, questionnaireFlow?: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, skipperFlow?: { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, signInFlow?: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } } | null };

export type RequestCodeViaEmailMutationVariables = Types.Exact<{
  email: Types.Scalars['Email']['input'];
  redirect?: Types.InputMaybe<Types.Scalars['String']['input']>;
  additionalParams?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type RequestCodeViaEmailMutation = { __typename?: 'Mutation', requestCodeViaEmail: boolean | null };

export type RequestCodeViaTextMutationVariables = Types.Exact<{
  phone: Types.Scalars['String']['input'];
}>;


export type RequestCodeViaTextMutation = { __typename?: 'Mutation', requestCodeViaPhone: boolean | null };


export const LoginWithCodeDocument = gql`
    mutation loginWithCode($code: String!, $email: Email, $phone: String, $affiliateSlug: String, $affiliateExternalId: String, $affiliateFirstEncounteredAt: String) {
  loginWithCode(
    code: $code
    email: $email
    phone: $phone
    affiliateSlug: $affiliateSlug
    affiliateExternalId: $affiliateExternalId
    affiliateFirstEncounteredAt: $affiliateFirstEncounteredAt
  ) {
    id
    phoneVerified
    emailVerified
    tokens {
      accessToken
      refreshToken
    }
    customer {
      id
      signInFlow {
        ...SignInFlowFragment
      }
    }
  }
}
    ${SignInFlowFragmentFragmentDoc}` as unknown as DocumentNode<LoginWithCodeMutation, LoginWithCodeMutationVariables>;
export const CreateOneCustomerForCreateAccountDocument = gql`
    mutation createOneCustomerForCreateAccount($data: CustomerAndEnrollmentItemCreateInput!, $shouldGetTokens: Boolean!, $programFlow: Boolean!, $programId: ID, $questionnaireFlow: Boolean!, $skipperFlow: Boolean!, $flowIntent: FlowIntent, $signInFlow: Boolean!) {
  createOneCustomer(data: $data) {
    customer {
      id
      user {
        id
        nameFirst
        nameLast
        phone
        email
        tokens @include(if: $shouldGetTokens) {
          accessToken
          refreshToken
        }
      }
      ...FlowStateUpdateFragment
    }
  }
}
    ${FlowStateUpdateFragmentFragmentDoc}` as unknown as DocumentNode<CreateOneCustomerForCreateAccountMutation, CreateOneCustomerForCreateAccountMutationVariables>;
export const RequestCodeViaEmailDocument = gql`
    mutation requestCodeViaEmail($email: Email!, $redirect: String, $additionalParams: String) {
  requestCodeViaEmail(
    email: $email
    redirect: $redirect
    additionalParams: $additionalParams
  )
}
    ` as unknown as DocumentNode<RequestCodeViaEmailMutation, RequestCodeViaEmailMutationVariables>;
export const RequestCodeViaTextDocument = gql`
    mutation requestCodeViaText($phone: String!) {
  requestCodeViaPhone(phone: $phone, isMobile: true)
}
    ` as unknown as DocumentNode<RequestCodeViaTextMutation, RequestCodeViaTextMutationVariables>;